import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { BaseUserFragment, FullUserFragment, JobDetailsV2Fragment } from 'graphql.generated';


import { type ControlMeta } from '../../../new-opportunity/new-opportunity.state';
import { ActionSource } from '../../../state/action-sources';
import { LocationEditorState } from '../../job-overview/overview-locations/overview-locations.state';

import { AdditionalContactEditorField, AdditionalContactState, CustomerEditorField } from './job-create-customer.state';

export interface CustomerEdit {
	selectedCustomer?: FullUserFragment;
	givenName: string;
	familyName: string;
	phone?: string;
	email?: string;
	additionalContacts?: AdditionalContactState[];
	company?: string;
	selectedBillingLocation?: LocationEditorState['selectedLocation'];
}

export const JobCreateCustomerActions = createActionGroup({
	source: ActionSource.CUSTOMER_EDITOR,
	events: {
    'Edit Customer Button Clicked': emptyProps(),
		'Job Customer Loaded': props<{ job: JobDetailsV2Fragment }>(),
    'Set Customer Email Button Clicked': emptyProps(),
    'Set Customer Phone Button Clicked': emptyProps(),
    'Cancel Edit Customer Button Clicked': emptyProps(),
		'Customer Autocomplete Input Changed': props<{
			field: string;
			value: string;
			key?: string;
		}
		>(),
		'Existing Customer Selected': props<{
			existingCustomer: FullUserFragment
		}>(),
		'Existing Customer Pre Selected': props<{
			existingCustomer: FullUserFragment
		}>(),
		'Moving Date Selected': props<{
			movingDate: Date,
		}>(),
		'Referral Source Selected': props<{ referralSource: string }>(),
		'Customer Type Selected': props<{ customerType: string }>(),
		'Job Origin Selected': props<{ jobOrigin: string }>(),
		'Search Users Success': props<{ users: BaseUserFragment[]; field: CustomerEditorField }>(),
		'Search Users Error': props<{ error: Error }>(),

		'Discard Customer Changes': emptyProps(),
		'Accept Customer Changes': emptyProps(),
		'Clear Customer Button Clicked': emptyProps(),
		'Create New Customer Based On Existing': emptyProps(),

		'Customer Autocomplete Search Fired': props<{
			query: string;
			field: CustomerEditorField;
		}>(),
		'Customer Autocomplete Input Focused': props<{
			field: CustomerEditorField;
		}>(),
		'Customer Autocomplete Input Blur': props<{
			field: CustomerEditorField;
		}>(),
		'Control Meta Updated': props<{
			field: string;
			meta: ControlMeta;
		}>(),
		'Control Meta Cleared': props<{
			field: string;
		}>(),
		'Update Customer Data Success': props<{
			jobId: string;
			updatedJob: JobDetailsV2Fragment;
			customerEdit?: CustomerEdit;
			customSuccessMessage?: string;
		}>(),
		'Update Customer Data Error': props<{
			error: Error;
		}>(),
		'Header Clicked': emptyProps(),
		'Clipboard Button Clicked': props<{ content: string }>(),
		'Send Message to Customer': props<{ commentModeId: string }>(),

		'Add Additional Contact Button Clicked': emptyProps(),
		'Additional Contact Field Changed': props<{
			index: number;
			field: AdditionalContactEditorField;
			value: string;
		}>(),
		'Remove Additional Contact Button Clicked': props<{ index: number }>(),
		'Existing Additional Contact Selected': props<{
			index: number;
			existingContact: FullUserFragment;
		}>(),
		'Additional Contact Edit Mode Changed': props<{
			index: number;
			isEditMode: boolean;
		}>(),
	},
});
